import { Track } from 'models/Track';
import { createContext, useContext, useEffect, useState } from 'react';

export type MusicPlayerContextType = {
  position: number;
  duration: number;
  currentTime: number;
  volume: number;
  muted: boolean;
  paused: boolean;
  tracks: Track[];
  trackIndex: number;
  play: () => void;
  pause: () => void;
  mute: (value: boolean) => void;
  setVolume: (value: number) => void;
  setPosition: (value: number) => void;
  setTrackIndex: (value: number) => void;
  setTracks: (value: Track[]) => void;
};

export const MusicPlayerContext = createContext<MusicPlayerContextType | null>(null);

export function MusicPlayerProvider({ children }: { children: React.ReactNode }) {
  // const [duration, setDuration] = useState(0);
  // const [position, setPosition] = useState(0);
  // const [volume, setVolume] = useState(50);
  // const [muted, setMuted] = useState(false);
  // const [paused, setPaused] = useState(true);
  const [trackIndex, setTrackIndex] = useState(0);
  const [tracks, setTracks] = useState<Track[]>([]);
  const [audioEl, _setAudioEl] = useState<HTMLAudioElement>(new Audio());

  // const play = () => {
  //   audioEl.play();
  // }

  // const pause = () => {
  //   audioEl?.pause();
  //   setPaused(true);
  // }

  // const mute = (muted: boolean) => {
  //   setMuted(muted || volume == 0);

  //   if (audioEl) {
  //     audioEl.muted = muted || volume == 0;
  //   }
  // }

  useEffect(() => {
    if (tracks.length && tracks[trackIndex]) {
      audioEl.src = tracks[trackIndex].previewUrl || '';
    }
  }, [tracks, trackIndex]);

  // useEffect(() => {
  //   if (tracks.length) {
  //     audioEl.pause();
  //     audioEl.src;

  //     audioEl.addEventListener('loadedmetadata', () => {
  //       setDuration(Math.round(newAudioEl.duration));
  //       setPosition(0);
  //       setAudioEl(newAudioEl);
  //       newAudioEl.volume = Math.min(1, Math.max(0, volume / 100));
  //       newAudioEl.muted = muted;
  //     });

  //     audioEl.addEventListener('pause', () => setPaused(true));
  //     audioEl.addEventListener('play', () => setPaused(false));

  //     if (!paused) {
  //       newAudioEl.play();
  //     }
  //   }
  // }, []);

  // useEffect(() => {
  //   setMuted(volume == 0);

  //   if (audioEl) {
  //     audioEl.volume = Math.min(1, Math.max(0, volume / 100));
  //     audioEl.muted = volume == 0;
  //   }
  // }, [volume]);

  // useEffect(() => {
  //   if (audioEl) {
  //     audioEl.currentTime = Math.min(duration, Math.max(0, position));
  //   }
  // }, [position]);

  return (
    <MusicPlayerContext.Provider
      value={{
        tracks,
        trackIndex,
        duration: Math.round(audioEl.duration) || 0,
        position: Math.round(audioEl.currentTime),
        currentTime: Math.round(audioEl.currentTime),
        volume: audioEl.volume,
        muted: audioEl.muted,
        paused: audioEl.paused,
        play: () => audioEl.play(),
        pause: () => audioEl.pause(),
        mute: (value: boolean) => (audioEl.muted = value || audioEl.volume == 0),
        setTrackIndex,
        setTracks,
        setPosition: (value: number) => {
          audioEl.currentTime = value;
          // audioEl.currentTime = Math.min(Math.round(audioEl.currentTime), Math.max(0, value))
        },
        setVolume: (value: number) => {
          audioEl.volume = Math.min(1, Math.max(0, value / 100));
          audioEl.muted = value == 0;
        },
      }}
    >
      {children}
    </MusicPlayerContext.Provider>
  );
}

// export function MusicPlayerProvider({ children }: { children: React.ReactNode }) {
//   const [duration, setDuration] = useState(0);
//   const [position, setPosition] = useState(0);
//   const [volume, setVolume] = useState(50);
//   const [muted, setMuted] = useState(false);
//   const [paused, setPaused] = useState(true);
//   const [trackIndex, setTrackIndex] = useState(0);
//   const [tracks, setTracks] = useState<ITrack[]>([]);
//   const [audioEl, setAudioEl] = useState<HTMLAudioElement>();

//   const play = () => {
//     audioEl?.play();
//     setPaused(false);
//   }

//   const pause = () => {
//     audioEl?.pause();
//     setPaused(true);
//   }

//   const mute = (muted: boolean) => {
//     setMuted(muted || volume == 0);

//     if (audioEl) {
//       audioEl.muted = muted || volume == 0;
//     }
//   }

//   useEffect(() => {
//     if (tracks.length) {
//       audioEl?.pause();

//       // const newAudioEl = new Audio(tracks[trackIndex].previewUrl);
//       audioEl.src;

//       newAudioEl.addEventListener('loadedmetadata', () => {
//         setDuration(Math.round(newAudioEl.duration));
//         setPosition(0);
//         setAudioEl(newAudioEl);
//         newAudioEl.volume = Math.min(1, Math.max(0, volume / 100));
//         newAudioEl.muted = muted;
//       });

//       newAudioEl.addEventListener('pause', () => setPaused(true));
//       newAudioEl.addEventListener('play', () => setPaused(false));

//       if (!paused) {
//         newAudioEl.play();
//       }
//     }
//   }, [tracks, trackIndex]);

//   useEffect(() => {
//     setMuted(volume == 0);

//     if (audioEl) {
//       audioEl.volume = Math.min(1, Math.max(0, volume / 100));
//       audioEl.muted = volume == 0;
//     }
//   }, [volume]);

//   useEffect(() => {
//     if (audioEl) {
//       audioEl.currentTime = Math.min(duration, Math.max(0, position));
//     }
//   }, [position]);

//   return (
//     <MusicPlayerContext.Provider value={{
//       duration,
//       position,
//       volume,
//       muted,
//       paused,
//       tracks,
//       trackIndex,
//       play,
//       pause,
//       mute,
//       setPosition,
//       setVolume,
//       setTrackIndex,
//       setTracks,
//     }}>
//       {children}
//     </MusicPlayerContext.Provider>
//   );
// }

export function useMusicPlayer() {
  const context = useContext(MusicPlayerContext);

  if (!context) {
    throw new Error('useMusicPlayer must be used within a MusicPlayerProvider');
  }

  return context;
}
